import React, { forwardRef, Ref } from 'react';
import AtlaskitAppProvider, { RouterLinkComponentProps } from '@atlaskit/app-provider';
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router-dom';

/**
 * This component is used to replace Atlaskit linking components with links that use react-router-dom for navigation.
 * The AppProvider determines when to use this component (it does not replace all Atlaskit linking components).
 * See https://atlassian.design/components/primitives/anchor/examples#router-links for more details.
 */
const RouterLinkComponent = forwardRef(
  (
    { href, children, ...rest }: RouterLinkComponentProps<ReactRouterLinkProps>,
    ref: Ref<HTMLAnchorElement>
  ) => {
    if (typeof href === 'string') {
      return (
        <ReactRouterLink ref={ref} to={href} {...rest}>
          {children}
        </ReactRouterLink>
      );
    }

    return (
      <ReactRouterLink ref={ref} {...href} {...rest}>
        {children}
      </ReactRouterLink>
    );
  }
);
RouterLinkComponent.displayName = 'RouterLinkComponent';

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <AtlaskitAppProvider routerLinkComponent={RouterLinkComponent}>{children}</AtlaskitAppProvider>
  );
};

export default AppProvider;
